import api, { handleAPIErrors } from "shared/api";

const FETCH_REQUEST = "peerComparisonReportActions/FETCH_REQUEST";
const FETCH_SUCCESS = "peerComparisonReportActions/FETCH_SUCCESS";
const FETCH_FAILURE = "peerComparisonReportActions/FETCH_FAILURE";
const RESET_RESULTS = "peerComparisonReportActions/RESET_RESULTS";

const initialState = {
  result: [],
  loading: false,
  loaded: false,
  errors: {},
};

export function fetchRequest() {
  return {
      type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
      type: FETCH_SUCCESS,
      payload,
  }
}

export function fetchFailure(errors) {
  return {
      type: FETCH_FAILURE,
      errors,
  }
}

export function resetResult(errors) {
  return {
      type: RESET_RESULTS
  }
}

export function resetReportsResult() {
  return (dispatch) => {
    dispatch(resetResult());
  }
}

export function loadReport(options, cb = null) {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api(`api/v1/remuneration_policies/peer_group_comparison`, options)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        dispatch(fetchSuccess(json));

        if (cb) cb();
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors));
        });

        if (cb) cb();
      });
  };
}

export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case RESET_RESULTS:
      return Object.assign({}, state, {
        result: []
      });
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      });
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors: errors,
      });
    default:
      return state;
  }
}
